var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('invoices')))]),_c('v-card-subtitle',[_vm._v(_vm._s(_vm.$t('allCurrentInvoices')))]),_c('BillingList',{attrs:{"bills":_vm.bills,"processing":_vm.bills === null}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }